// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"Loader_loader-wrapper__JbTaL","page-loader":"Loader_page-loader__KBie6","loader":"Loader_loader__w3umZ","spin":"Loader_spin__lRMlT"};